import React, { useState, useEffect } from "react";
import useDarkMode from '../../../hooks/useDarkMode';
import Select from "react-select";
import DropDownStyles, { DropDownStylesDark } from "../../../pages/staff/dropdownStyles.js";

const PageSizeDropDownSelection = ({ defaultValue, onChange, className }) => {
  const pageSizeOptions = [
    { value: "20", label: "20" },
    { value: "50", label: "50" },
    { value: "100", label: "100" },
  ];

  // Check if dark mode is enabled
  const isDarkMode = useDarkMode();
  const dropdownStyles = isDarkMode ? DropDownStylesDark : DropDownStyles;

  

  return (
    <div className={className}>
      <Select
        key={`pagesize-${isDarkMode}`}
        defaultValue={defaultValue}
        onChange={onChange}
        options={pageSizeOptions}
        styles={dropdownStyles}
        placeholder={"Page Size"}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        menuShouldBlockScroll={false}
        menuShouldScrollIntoView={false}
        closeMenuOnScroll={false}
      />
    </div>
  );
};

export default PageSizeDropDownSelection;

export const SortOrderDropDownSelection = ({ defaultValue, onChange }) => {
  const sortOrderOptions = [
    { value: "DESC", label: "Desc" },
    { value: "ASC", label: "Asc" },
  ];

  // Check if dark mode is enabled
  const isDarkMode = useDarkMode();
  const dropdownStyles = isDarkMode ? DropDownStylesDark : DropDownStyles;

  

  return (
    <Select
      key={`sortorder-${isDarkMode}`}
      defaultValue={defaultValue}
      onChange={onChange}
      options={sortOrderOptions}
      styles={dropdownStyles}
      placeholder={"Sort Order"}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      menuShouldBlockScroll={false}
      menuShouldScrollIntoView={false}
      closeMenuOnScroll={false}
    />
  );
};

export const GenderDropDownSelection = ({
  defaultValue,
  onChange,
  selectedValue,
}) => {
  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];

  // Check if dark mode is enabled
  const isDarkMode = useDarkMode();
  const dropdownStyles = isDarkMode ? DropDownStylesDark : DropDownStyles;

  

  return (
    <Select
      key={`gender-${isDarkMode}`}
      defaultValue={defaultValue}
      value={genderOptions.find((option) => option.value === selectedValue)}
      onChange={onChange}
      options={genderOptions}
      styles={dropdownStyles}
      placeholder="Select Gender"
      isClearable={true}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      menuShouldBlockScroll={false}
      menuShouldScrollIntoView={false}
      closeMenuOnScroll={false}
    />
  );
};
